import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/30 border-y border-slate-800/50" data-id="element-510">
      <motion.div className="max-w-4xl mx-auto" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-511">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-10 text-center tracking-tight" data-id="element-512">
          EL PROBLEMA QUE NADIE NOMBRA
        </h2>

        <div className="space-y-8 text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-513">
          <p data-id="element-514">Hay dos tipos de dueños de empresa en el mundo.</p>

          <p data-id="element-515">
            El primero trabaja <strong className="text-amber-500" data-id="element-516">en</strong> su
            empresa. Está en cada reunión, aprueba cada decisión, resuelve cada
            problema. Es indispensable. Su empresa no puede funcionar sin él. Y
            en el fondo, aunque no lo admita, sabe que eso es un problema
            enorme.
          </p>

          <p data-id="element-517">
            El segundo trabaja{' '}
            <strong className="text-emerald-500" data-id="element-518">sobre</strong> su empresa.
            Diseñó los procesos, estructuró su equipo, definió los indicadores.
            Su empresa funciona aunque él esté de vacaciones. Tiene tiempo para
            pensar en el futuro porque el presente ya tiene quien lo gestione.
          </p>

          <p data-id="element-519">
            La diferencia entre estos dos tipos de dueños no es el tamaño de la
            empresa. No es la cantidad de empleados. No es el capital
            disponible.
          </p>

          <div className="bg-slate-800/50 p-6 md:p-8 rounded-xl border border-slate-700 text-center mt-10" data-id="element-520">
            <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-521">
              Es el sistema organizacional que tienen detrás.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}